import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site";

const cats = [
    { title: "Manufacturing & Production", tag: "ITI · Diploma · Operators", img: IMAGES.manufacturing, span: "md:col-span-7" },
    { title: "Corporate & Office Staff", tag: "Graduates · Admin · Back-office", img: IMAGES.office, span: "md:col-span-5" },
    { title: "Housekeeping Services", tag: "Cleaning · Facility · Pantry", img: IMAGES.housekeeping, span: "md:col-span-5" },
    { title: "Logistics & Warehouse", tag: "Drivers · Loaders · Packers", img: IMAGES.logistics, span: "md:col-span-7" },
];

export const JobCategories = () => {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative py-28 sm:py-32 px-5 sm:px-8"
        >
            <div className="mx-auto max-w-7xl">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <span className="text-xs tracking-[0.35em] text-[#F47B20] uppercase font-semibold">
                            What We Staff
                        </span>
                        <h2 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold text-white">
                            Roles across every industry
                        </h2>
                    </div>
                    <p className="text-slate-400 max-w-sm">
                        Whether you are looking for skilled technicians or dependable
                        entry-level hands, we place candidates of every background.
                    </p>
                </div>

                <div className="grid md:grid-cols-12 gap-5">
                    {cats.map((c, i) => (
                        <motion.div
                            key={c.title}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            data-testid={`service-card-${i}`}
                            className={`group relative overflow-hidden rounded-3xl ${c.span} h-72 sm:h-80 ring-1 ring-white/10`}
                        >
                            <img
                                src={c.img}
                                alt={c.title}
                                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-[#050B14]/40 to-transparent" />
                            <div className="absolute bottom-0 left-0 p-7">
                                <span className="text-xs tracking-widest uppercase text-[#F47B20] font-semibold">
                                    {c.tag}
                                </span>
                                <h3 className="mt-2 font-display text-2xl font-bold text-white">
                                    {c.title}
                                </h3>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
